import { render, staticRenderFns } from "./ShareIcon.vue?vue&type=template&id=81f5983c&scoped=true&"
import script from "./ShareIcon.vue?vue&type=script&lang=js&"
export * from "./ShareIcon.vue?vue&type=script&lang=js&"
import style0 from "./ShareIcon.vue?vue&type=style&index=0&id=81f5983c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f5983c",
  null
  
)

export default component.exports